import React, {useEffect, useState} from "react";
import {Layout} from "antd";

import {Outlet, useLocation, useNavigate} from "react-router-dom";
import LayoutHeader from "../components/common/LayoutHeader";
import LayoutSiderMenu from "../components/common/LayoutSiderMenu";
import {WaterMark} from "@ant-design/pro-layout";
import {ApiService, LOGIN_USER} from "../services/ApiService";
import {PRODUCT_IS_PUBLIC} from "../routers/routerConfig";


const {Content} = Layout;

const MainTemplate = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [collapsed, setCollapsed] = useState(true)
    const [user, setUser] = useState({})

    useEffect(() => {
        ApiService.user.current()
            .onSuccess(user => {
                setUser(user)
            })
            .onError((msg, code) => {
                navigate('/login')
            })
    }, [location]);

    const handleCollapsed = (newValue) => {
        setCollapsed(newValue)
    }

    return (
        <Layout>
            <LayoutHeader hideText={collapsed} user={user}/>
            <Layout style={{
                paddingTop: 64,
                minHeight: '100vh'
            }}>
                <LayoutSiderMenu
                    user={user}
                    collapsed={collapsed}
                    onCollapsed={handleCollapsed}
                />

                <Layout style={{
                    padding: '24px 24px',
                    marginLeft: collapsed ? 35 : 200,
                }}>
                    <Content>
                        <WaterMark fontSize={10} fontColor={PRODUCT_IS_PUBLIC ? 'rgba(0, 122, 207, 0.12)' : 'rgba(228, 49, 49, 0.14)'}
                                   content={`${PRODUCT_IS_PUBLIC ? '' : '【机密】'} ${user?.properties?.regionName} ${user?.username}`} gapX={100} gapY={PRODUCT_IS_PUBLIC ? 260: 100}>
                            <Outlet/>
                        </WaterMark>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    )
}

export default MainTemplate